module.exports = __webpack_public_path__ + "static/media/p7.60d1f173.png";